import { combineReducers } from 'redux';

import legacy from './legacy/shared/reducer';
import hodor from './hodor/reducer';

export default combineReducers({
  legacy,
  hodor
});
